import { msg } from '~/utils/validation';
import { z } from 'zod';

export const schema = z.object({
  division: z.coerce.number({ message: msg.required }),
  name: z
    .string()
    .min(1, { message: msg.required })
    .max(100, { message: 'Namnet får inte vara längre än 100 tecken' }),
  club: z
    .tuple([z.string(), z.number()])
    .nullable()
    .optional(),
});

export type Schema = z.infer<typeof schema>;
